import moment, { Moment } from "moment";

export interface CheckInProgressDto {
  regular: { total: number; checkedIn: number };
  spare: { total: number; checkedIn: number };
}

export class CheckInProgress {
  regular: { total: number; checkedIn: number };
  spare: { total: number; checkedIn: number };
  updatedAt: Moment;

  constructor(dto: CheckInProgressDto) {
    this.regular = JSON.parse(JSON.stringify(dto.regular));
    this.spare = JSON.parse(JSON.stringify(dto.spare));
    this.updatedAt = moment();
  }
}
